import React from 'react';
import classNames from 'classnames';

import RichText from '~/components/patterns/typography/RichText';



export enum KevinSaysAlignment {
	Left = 'left',
	Right = 'right',
}

export enum KevinSaysSize {
	Default = 'default',
	Large = 'large',
}

export enum KevinSaysStyle {
	Default = 'default',
	Greyscale = 'greyscale',
}

type Props = {
	alignment?: KevinSaysAlignment,
	bubble?: boolean,
	centered?: boolean,
	children: React.ReactNode,
	maxWidth?: number,
	style?: KevinSaysStyle,
	size?: KevinSaysSize,
};



const KevinSays: React.FC<Props> = (props) => {
	const {
		alignment = KevinSaysAlignment.Right,
		bubble = true,
		centered = true,
		children,
		maxWidth,
		size = KevinSaysSize.Default,
		style = KevinSaysStyle.Default,
	} = props;

	const componentClasses = classNames({
		'kevin-says': true,
		'kevin-says--centered': centered,
		'kevin-says--left-aligned': alignment === KevinSaysAlignment.Left,
		'kevin-says--right-aligned': alignment === KevinSaysAlignment.Right,
		'kevin-says--has-bubble': bubble,

		'kevin-says--greyscale-style': style === KevinSaysStyle.Greyscale,

		'kevin-says--large-size': size === KevinSaysSize.Large,
	});

	const componentStyle: React.CSSProperties = {};

	if (maxWidth) {
		componentStyle.maxWidth = maxWidth;
	}

	return (
		<div
			className={componentClasses}
			style={componentStyle}
		>
			<div className="kevin-says__ie-fix">
				<div className="kevin-says__bubble">
					<div className="kevin-says__content">
						<RichText>
							{children}
						</RichText>
					</div>
				</div>
			</div>
		</div>
	);
};



export default KevinSays;
